import Vue from "vue";
import IdleVue from 'idle-vue';
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
//import ApiService from "@/core/services/api.service";
import ApiService from "@/core/services/bbapi.service";
//import MockService from "@/core/mock/mock.service";
import Vuelidate from "vuelidate";
import { VERIFY_AUTH } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";

import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'

// code block formatting
import VueHighlightJS from 'vue-highlight.js'
Vue.use(VueHighlightJS);

var teloptions = {
        mode: "international",
        defaultCountry: "US",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: "Enter a phone number",
        required: true,
        enabledCountryCode: false,
        enabledFlags: true,
        preferredCountries: [],  //["AU", "BR"]
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: "off",
        name: "telephone",
        maxLen: 25,
        wrapperClasses: "",
        inputClasses: "",
        dropdownOptions: {
            disabledDialCode: false
        },
        inputOptions: {
            showDialCode: false,
            //required: true,
        }
    }
    Vue.use(VueTelInput, teloptions);

//Vue.use(VueTelInput);


//https://github.com/soixantecircuits/idle-vue#readme
//https://medium.com/js-dojo/how-to-set-timer-idle-in-vue-1f4b57beb886
//Idle Timeout
const eventsHub = new Vue();

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: 24 * 60 * 60 * 1000,
    startAtIdle: false,
    events: ["mousedown"]
});


// API service init
ApiService.init();

// Remove this to disable mock API
//MockService.init();

router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.requiresAuth)) {
        Promise.all([store.dispatch(VERIFY_AUTH)])
            .then(
                function () {
                    if (store.getters.isAuthenticated) {
                        next();
                    }
                    else {
                        next('/login');
                    }
                }
            );
    }
    else {
        next();
    }


    // reset config to initial state
    store.dispatch(RESET_LAYOUT_CONFIG);

    // Scroll page to top on every route change
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);
});


Vue.use(Vuelidate);

export const eventbus = new Vue();

var vm = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");

//Vue logger
import VueLogger from 'vuejs-logger';
const isProduction = process.env.NODE_ENV === 'production';

const options = {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};

Vue.use(VueLogger, options);

window.vm = vm;

